import AffirmationTranslationsResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationTranslationsResponse";
import AffirmationTranslationsUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationTranslationsUpdateRequest";

export default class AffirmationTranslateModel {
    langCode: string = '';
    name: string = '';
    description: string = '';
    text: string = '';

    constructor(obj?: Partial<AffirmationTranslateModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    private normalizeText(value: string): string | undefined {
        const text = (value || "").trim();
        return text ? text : undefined;
    }

    hasAnyContent(): boolean {
        return !!(
            this.normalizeText(this.name) ||
            this.normalizeText(this.description) ||
            this.normalizeText(this.text)
        );
    }

    hasContent(): boolean {
        return !!this.normalizeText(this.name);
    }

    toServerModel(): AffirmationTranslationsUpdateRequest {
        const name = this.normalizeText(this.name);
        return new AffirmationTranslationsUpdateRequest({
            LangCode: this.langCode,
            Name: name,
            Description: name,
            Text: name,
        });
    }

    fromServerModel(model: AffirmationTranslationsResponse) {
        this.langCode = model.LangCode;
        this.name = model.Name;
        this.description = model.Description;
        this.text = model.Text;
    }
}
